import { arrayToSimpleObj } from '../utils';

export const gameTypeOptions = [
  { value: 'mobile', text: 'Mobile' },
  { value: 'pc', text: 'PC' },
  { value: 'console', text: 'Console' },
];

export const gameTypeMap = arrayToSimpleObj(gameTypeOptions);
